import { render, staticRenderFns } from "./LiveDetail.vue?vue&type=template&id=7c34e415&scoped=true&"
import script from "./LiveDetail.vue?vue&type=script&lang=js&"
export * from "./LiveDetail.vue?vue&type=script&lang=js&"
import style0 from "./LiveDetail.vue?vue&type=style&index=0&id=7c34e415&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c34e415",
  null
  
)

export default component.exports